<template>
  <div class="btns" :style="{justifyContent: align?align:'center'}">
    <CancelBtn @click="$emit('cancel')" :style="{height:'35px', fontSize: '16px'}"/>
    <RoundBtn @click="$emit('temp')" :text="temp" :style="save?{minWidth: 'fit-content', paddingInline: '16.5px', height:'35px', fontSize: '16px'}:{height:'35px', fontSize: '16px'}"/>
    <SaveBtn @click="$emit('save')" :text="save" :style="save?{minWidth: 'fit-content', paddingInline: '16.5px', height:'35px', fontSize: '16px'}:{height:'35px', fontSize: '16px'}"/>
  </div>
</template>

<script>
import RoundBtn from './saveTemp.vue'
import SaveBtn from './save.vue'
import CancelBtn from './cancel.vue'
export default {
  props: ['align', 'temp', 'save'],
  components: {
    SaveBtn,
    CancelBtn,
    RoundBtn
  }

}
</script>

<style lang="scss" scoped>
.btns {
  display: flex;
  align-items: center;
  gap: 25px;
  width: 100%;
}
</style>
